import * as Sentry from '@sentry/react';

const dsn = import.meta.env.VITE_SENTRY_DSN;

export function initSentry() {
  if (!dsn) {
    console.log('[Sentry] No DSN configured, skipping initialization');
    return;
  }

  Sentry.init({
    dsn,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || 'production',
    enabled: import.meta.env.PROD,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({ maskAllText: false, blockAllMedia: false }),
    ],
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0.05,
    replaysOnErrorSampleRate: 1.0,
    beforeSend(event) {
      // Sía burt villur frá vafra-viðbótum (browser extensions)
      if (event.exception?.values?.[0]?.stacktrace?.frames?.some(
        f => f.filename?.includes('extension') || f.filename?.includes('cs.js')
      )) {
        return null;
      }
      return event;
    },
  });
}

export function setSentryUser(user) {
  if (!user) return;
  Sentry.setUser({
    id: user.sub,
    email: user.email,
    username: user.name,
  });
}

export function clearSentryUser() {
  Sentry.setUser(null);
}

export { Sentry };
